import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AdminGuard } from "../../guards/RolesGuard";
import { classNames } from "../../utils/classNames";
import { useGetCurrentUserQuery } from "../../store/user/userApi";

let navigationAgents = [
  { name: "Purchases", href: "/purchase-orders", icon: <img alt="purchase-orders" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="purchase-orders" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
  { name: "Reconciliations", href: "/reconciliations", icon: <img alt="reconciliations" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="purchase-orders" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
  { name: "AR (Account Receivable)", href: "/account-receivable", icon: <img alt="account-receivable" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="account-receivable" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
  { name: "AP (Account Payable)", href: "/account-payable", icon: <img alt="account-payable" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="account-payable" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
  { name: "AI Agent Activities", href: "/ai-agent-activities", icon: <img alt="ai-agent-activities" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="ai-agent-activities" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true, access: 'partners' },
  { name: "Clients", href: "/clients", icon: <img alt="clients" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="purchase-orders" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
  { name: "Members", href: "/members", icon: <img alt="members" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="purchase-orders" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true, access: 'partners' },
];

const navigationAdmin = [
  { name: "Users", href: "/users", icon: <img alt="users" src="/assets/navigation/shared-icon.svg" />, iconEnabled: <img alt="purchase-orders" src="/assets/navigation/shared-icon-enabled.svg" />, enabled: true },
];

const extraNavigation = [
  { name: "Profile", href: "/settings", icon: <img alt="profile" src="/assets/navigation/profile.svg" />, iconEnabled: <img alt="profile" src="/assets/navigation/profile.svg" />, enabled: true },
]


const Navigation = () => {
  const location = useLocation();
  const isAdmin = AdminGuard();
  const [activeRoute, setActiveRoute] = useState<string>()
  const { data } = useGetCurrentUserQuery();
  const userRole = data?.groups?.[0] || localStorage.getItem('roles') || '';

  useEffect(() => {
    setActiveRoute(location.pathname)
  }, [location])

  return (
    <>
      {isAdmin ? (
        <>
          {navigationAdmin.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  "text-base group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-dm_sans_regular",
                  item.enabled && isActive
                    ? "bg-[#8DF24C] text-primary-default"
                    : "text-secondary"
                )
              }
            >
              {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
              {item.icon ? (
                <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                  {activeRoute === item?.href ?
                    React.cloneElement(item?.iconEnabled || item.icon, {
                      width: 20,
                      height: 20,
                    })
                    : React.cloneElement(item.icon, {
                      width: 20,
                      height: 20,
                    })
                  }
                </span>
              ) : (
                <span className="flex w-8" />
              )}
              {item.name}
            </NavLink>
          ))}
        </>
      ) : (

        <>
          {navigationAgents.filter((item: any) => !item?.access || item.access === userRole)?.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  "text-base group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-dm_sans_regular",
                  item.enabled && isActive
                    ? "bg-[#8DF24C] text-primary-default"
                    : "text-secondary"
                )
              }
            >
              {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
              {item.icon ? (
                <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                  {activeRoute === item?.href ?
                    React.cloneElement(item?.iconEnabled || item.icon, {
                      width: 20,
                      height: 20,
                    })
                    : React.cloneElement(item.icon, {
                      width: 20,
                      height: 20,
                    })
                  }
                </span>
              ) : (
                <span className="flex w-8" />
              )}
              {item.name}
            </NavLink>
          ))}
          <div className='mt-14'>
            {extraNavigation?.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  classNames(
                    "text-base group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-dm_sans_regular",
                    item.enabled && isActive
                      ? "bg-[#8DF24C] text-primary-default"
                      : "text-secondary"
                  )
                }
              >
                {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
                {item.icon ? (
                  <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                    {activeRoute === item?.href ?
                      React.cloneElement(item?.iconEnabled || item.icon, {
                        width: 20,
                        height: 20,
                      })
                      : React.cloneElement(item.icon, {
                        width: 20,
                        height: 20,
                      })
                    }
                  </span>
                ) : (
                  <span className="flex w-8" />
                )}
                {item.name}
              </NavLink>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Navigation;
